import React, { useEffect, useMemo, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import {
  cleanAll,
  getAll,
  setDone,
  edit,
  setSchedule,
} from "../../../store/reducers/todosReducer";
import { sendSmsScheduled } from "../../../store/reducers/dataReducer";
import { toast } from "react-toastify";
import {
  BoldFont,
  FlexRowBetween,
  ListHolder,
  MediumFont,
  RespFont,
  TextWithPic,
  TodoCard,
} from "../../common/Style";
import Accordion from "react-bootstrap/Accordion";
import Switcher from "../../common/switcher/Switcher";
import BottomMenu from "../../common/others/BottomMenu";
import plus from "../../../assets/common/plus.svg";
import tools from "../../../assets/common/menu.svg";
import logout from "../../../assets/common/logout.svg";
import FilledLoading from "../../common/loader/FilledLoading";
import GenericModal from "../../common/modals/GenericModal";
import YesNoModal from "../../common/modals/YesNoModal";
import Add, {
  canRole5ScheduleMessages,
  getRole5PackageMissingLabels,
} from "./Add";
import Edit from "./Edit";
import ToolsOptions from "../ToolsOptions";
import ClientRoutes from "../../../navigation/Routes";
import { useHistory } from "react-router-dom";
import LogoutSpecipic from "../../common/LogOut/LogoutSpecipic";
import SetCallsRecord from "./SetCallsRecord";
import { getPaymentDetails } from "../../../store/reducers/dataReducer";
import GetPaymentDetails from "./GetPaymentDetails";
import { post } from "../../../store/api/http";
import ServerRoutes from "../../../store/api/routes";

// קומפוננט תפריט בורגר
const BurgerMenu = ({
  isOpen,
  onToggle,
  children,
  position = "relative",
  top,
  left,
}) => {
  return (
    <div
      style={{
        position: position,
        zIndex: 1000,
        ...(top && { top }),
        ...(left && { left }),
      }}
    >
      {/* כפתור הבורגר */}
      <button
        onClick={(e) => {
          e.stopPropagation();
          onToggle();
        }}
        style={{
          background: "#fff",
          color: "white",
          border: "none",
          borderRadius: "0px 0px 12px 0px",
          padding: "10px 12px 12px 10px",
          cursor: "pointer",
          fontSize: 14,
          width: "44px",
          height: "44px",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          boxShadow: "0 2px 8px rgba(0,0,0,0.15)",
          transition: "all 0.3s ease",
        }}
        title="תפריט"
      >
        <div
          style={{
            width: "23px",
            height: "2px",
            background: "#5377bb",
            position: "relative",
            transition: "all 0.3s ease",
            transform: isOpen ? "rotate(45deg)" : "none",
          }}
        >
          <div
            style={{
              position: "absolute",
              top: "-7px",
              left: "0",
              width: "100%",
              height: "100%",
              background: "#5377bb",
              transition: "all 0.3s ease",
              opacity: isOpen ? "0" : "1",
            }}
          />
          <div
            style={{
              position: "absolute",
              top: "7px",
              left: "0",
              width: "100%",
              height: "100%",
              background: "#5377bb",
              transition: "all 0.3s ease",
              transform: isOpen ? "rotate(-90deg)" : "none",
            }}
          />
        </div>
      </button>

      {/* תפריט נפתח */}
      {isOpen && (
        <div
          onClick={(e) => e.stopPropagation()}
          style={{
            position: "absolute",
            top: "44px",
            left: "0",
            background: "white",
            borderRadius: "12px",
            boxShadow: "0 8px 32px rgba(0,0,0,0.2)",
            padding: "16px",
            minWidth: "200px",
            maxHeight: "80vh",
            overflowY: "auto",
            overflowX: "hidden",
            animation: "slideIn 0.3s ease",
          }}
        >
          {children}
        </div>
      )}
    </div>
  );
};

// קומפוננט פריט תפריט
const MenuItem = ({
  icon,
  text,
  onClick,
  color = "#5377bb",
  disabled = false,
}) => {
  return (
    <button
      onClick={(e) => {
        e.stopPropagation();
        if (!disabled) onClick();
      }}
      disabled={disabled}
      style={{
        display: "flex",
        alignItems: "center",
        gap: "12px",
        width: "100%",
        padding: "12px 16px",
        background: "transparent",
        border: "none",
        borderRadius: "8px",
        cursor: disabled ? "not-allowed" : "pointer",
        color: disabled ? "#999" : color,
        fontSize: "14px",
        fontWeight: "500",
        transition: "all 0.2s ease",
        opacity: disabled ? 0.6 : 1,
      }}
      onMouseEnter={(e) => {
        if (!disabled) {
          e.target.style.background = "#f8f9fa";
        }
      }}
      onMouseLeave={(e) => {
        e.target.style.background = "transparent";
      }}
    >
      <div style={{ display: "flex", alignItems: "center" }}>{icon}</div>
      <span>{text}</span>
    </button>
  );
};

const dict = {
  ראשונה: 1,
  שניה: 2,
  שלישית: 3,
  רביעית: 4,
  חמישית: 5,
};

const scheduleTitleDict = {
  הודעה: "ac",
  ווצאפ: "ac",
  שיחה: "ac",
  קדם: "kdam",
  תזכורת: "reminder",
  תודה: "thank",
  ערב: "reminder",
};

const isFilled = (v) => v != null && String(v).trim() !== "";

const isEventReadyForSchedule = (user) => {
  if (!user) return false;
  if (user.isReady === false) return false;
  if (user.role === 1 && user.isReadyAdmin === false) return false;
  if (user.eventType) {
    if (
      !isFilled(user.brideFN) ||
      !isFilled(user.brideLN) ||
      !isFilled(user.groomFN) ||
      !isFilled(user.groomLN)
    )
      return false;
  } else if (!isFilled(user.calendarName)) return false;
  if (!isFilled(user.hour1)) return false;
  if (!isFilled(user.waze) || !String(user.waze).includes("https"))
    return false;
  if (user.date) {
    const eventDate = new Date(user.date);
    eventDate.setHours(23, 59, 59, 999);
    if (new Date() > eventDate) return false;
  }
  return true;
};

const isTaskDatePassed = (executionDate) => {
  if (!executionDate) return true;
  const taskDateStr =
    typeof executionDate === "string"
      ? executionDate.slice(0, 10)
      : new Date(executionDate).toISOString().slice(0, 10);
  const today = new Date().toISOString().slice(0, 10);
  return taskDateStr < today;
};

const getPreferredWindowByTitle = (title = "") => {
  const normalized = String(title).trim();
  if (normalized.startsWith("הודעה")) {
    if (normalized.includes("ראשונה")) return ["19:00", "20:00"];
    if (normalized.includes("שניה") || normalized.includes("שנייה"))
      return ["09:00", "10:00"];
  }
  if (normalized.startsWith("ווצאפ")) {
    if (normalized.includes("ראשון")) return ["19:00", "20:00"];
    if (normalized.includes("שני")) return ["09:00", "10:00"];
    if (normalized.includes("שלישי")) return ["13:00", "16:00"];
  }
  if (normalized.startsWith("שיחה")) {
    if (normalized.includes("ראשונה")) return ["09:00", "11:00"];
    if (normalized.includes("שניה")) return ["11:00", "13:00"];
    if (normalized.includes("שלישית")) return ["13:00", "15:00"];
    if (normalized.includes("רביעית")) return ["15:00", "17:00"];
  }
  if (normalized.startsWith("קדם")) return ["13:00", "16:00"];
  if (normalized.startsWith("תזכורת")) {
    if (normalized.includes("ווצאפ")) return ["11:30", "13:00"];
    return ["10:00", "11:30"];
  }
  if (normalized.startsWith("תודה")) return ["13:00", "16:00"];
  return ["09:00", "19:30"];
};

const timeToMinutes = (timeStr) => {
  const [h = 0, m = 0] = String(timeStr || "00:00")
    .split(":")
    .map(Number);
  return h * 60 + m;
};

const minutesToTime = (mins) => {
  const bounded = Math.max(0, Math.min(23 * 60 + 59, mins));
  const h = Math.floor(bounded / 60);
  const m = bounded % 60;
  return `${String(h).padStart(2, "0")}:${String(m).padStart(2, "0")}`;
};

const MainTodos = () => {
  const { guests } = useSelector((state) => state.guestsReducer);
  let history = useHistory();
  const dispatch = useDispatch();
  const { user, isTal } = useSelector((state) => state.authReducer);
  const { todos } = useSelector((state) => state.todosReducer);
  const [showEditTodo, setShowEditTodo] = useState(false);
  const [showAddTodo, setShowAddTodo] = useState(false);
  const [showMenu, setShowMenu] = useState(false);
  const [showLoading, setShowLoading] = useState(false);
  const [showLogout, setShowLogout] = useState(false);
  const [showCallsRecord, setShowCallsRecord] = useState(false);
  const [showPaymentDetails, setShowPaymentDetails] = useState(false);
  const [isMainMenuBurgerOpen, setIsMainMenuBurgerOpen] = useState(false);
  const [scheduleModalTodo, setScheduleModalTodo] = useState(null);
  const [scheduleTime, setScheduleTime] = useState("09:00");
  const [scheduleAlternatives, setScheduleAlternatives] = useState(null);
  const [cancelScheduleTodo, setCancelScheduleTodo] = useState(null);
  const [scheduleLoading, setScheduleLoading] = useState(false);
  const [bulkScheduleLoading, setBulkScheduleLoading] = useState(false);

  const role5PackageMissingLabels = useMemo(
    () => getRole5PackageMissingLabels(user?.deal, todos),
    [user?.deal, todos],
  );
  const role5ScheduleBlocked =
    user?.role === 5 && role5PackageMissingLabels.length > 0;

  const toastRole5PackageIncomplete = () => {
    toast.warning(
      `יש להוסיף ללו״ז את כל משימות החבילה לפני תזמון. חסר: ${role5PackageMissingLabels.join(" · ")}`,
    );
  };

  const setCallsRecords = (callNumber) => {
    let posC = 0;
    let negC = 0;
    if (Object.keys(guests).length > 0)
      for (const [key, value] of Object.entries(guests))
        if (value.ans.includes(`C${dict[callNumber]}`))
          if (value.ans.includes("לא")) negC++;
          else posC++;

    if (posC > 0 || negC > 0)
      setShowCallsRecord({ posC, negC, number: dict[callNumber] });
    else toast.warning(`עוד לא התקיימה שיחה ${callNumber}`);
  };

  useEffect(() => {
    setShowLoading(true);
    dispatch(getAll()).then((res) => {
      if (res.payload?.error) toast.error(res.payload?.error);
      setShowLoading(false);
    });
    return () => {
      dispatch(cleanAll());
    };
  }, []);

  const handleSetDone = async (id, done, callNumber) => {
    const body = { done };
    dispatch(setDone(id, body)).then((res) => {
      if (!res.payload?.error) {
        setCallsRecords(callNumber);
        toast.success("הפעולה בוצעה בהצלחה");
      } else toast.error(res.payload?.error);
    });
  };

  const handleSetPayment = async (executionDate) => {
    dispatch(getPaymentDetails()).then((res) => {
      if (!res.payload?.error)
        setShowPaymentDetails({
          ...res.payload,
          executionDate,
          mikdama: user.mikdama,
          date: user.date,
        });
      else toast.error(res.payload?.error);
    });
  };

  const getTaskDateStr = (executionDate) => {
    if (!executionDate) return "";
    const s =
      typeof executionDate === "string"
        ? executionDate
        : executionDate.toISOString?.() || "";
    return s.slice(0, 10);
  };

  const toIsraelHHmm = (dateStrOrDate) => {
    const d = new Date(dateStrOrDate);
    return d.toLocaleTimeString("he-IL", {
      timeZone: "Asia/Jerusalem",
      hour: "2-digit",
      minute: "2-digit",
      hour12: false,
    });
  };

  const getTodayIsraelDateStr = () => {
    return new Date().toLocaleDateString("en-CA", {
      timeZone: "Asia/Jerusalem",
    });
  };

  const getDefaultScheduleTime = () => {
    const tenMinLater = new Date(Date.now() + 10 * 60 * 1000);
    return tenMinLater.toLocaleTimeString("he-IL", {
      timeZone: "Asia/Jerusalem",
      hour: "2-digit",
      minute: "2-digit",
      hour12: false,
    });
  };

  const getMinScheduleTime = (taskDateStr) => {
    const today = getTodayIsraelDateStr();
    if (taskDateStr !== today) return "00:00";
    const tenMinLater = new Date(Date.now() + 10 * 60 * 1000);
    return tenMinLater.toLocaleTimeString("he-IL", {
      timeZone: "Asia/Jerusalem",
      hour: "2-digit",
      minute: "2-digit",
      hour12: false,
    });
  };

  const isTimeValidForSchedule = (dateStr, timeStr) => {
    const candidateMs = new Date(
      dateStr + "T" + timeStr + ":00+02:00",
    ).getTime();
    const minAllowedMs = Date.now() + 5 * 60 * 1000;
    return candidateMs > minAllowedMs;
  };

  const checkScheduleAvailability = async (
    todo,
    chosenTimeStr,
    platform = "sms",
  ) => {
    const dateStr = getTaskDateStr(todo.executionDate);
    if (!dateStr) return { free: false, alternatives: [] };
    const { data } = await post(ServerRoutes.SmsScheduled.date, {
      date: dateStr,
    });
    const list = data?.data ?? data ?? [];
    const requests = (Array.isArray(list) ? list : [])
      .map((r) => {
        const t = r.scheduledTime;
        if (!t) return null;
        const hhmm = toIsraelHHmm(t);
        const [h, m] = hhmm.split(":").map(Number);
        return {
          minutes: h * 60 + m,
          platform: r.platform || "sms",
        };
      })
      .filter(Boolean);
    const [chosenH, chosenM] = chosenTimeStr.split(":").map(Number);
    const chosenMinutes = (chosenH ?? 0) * 60 + (chosenM ?? 0);
    const isAllowed = (candidateMinutes) => {
      if (requests.some((r) => r.minutes === candidateMinutes)) return false;
      if (
        platform === "whatsapp" &&
        requests.some(
          (r) =>
            r.minutes > candidateMinutes && r.minutes < candidateMinutes + 3,
        )
      ) {
        return false;
      }
      if (
        requests.some(
          (r) =>
            r.platform === "whatsapp" &&
            candidateMinutes > r.minutes &&
            candidateMinutes < r.minutes + 3,
        )
      ) {
        return false;
      }
      return true;
    };
    if (isAllowed(chosenMinutes)) return { free: true };

    const maxBack = 60;
    const maxForward = 60;
    const step = 1;
    let before = null;
    let after = null;
    for (let i = step; i <= maxBack; i += step) {
      const mm = chosenMinutes - i;
      if (mm < 0) break;
      const hh = Math.floor(mm / 60) % 24;
      const min = mm % 60;
      const key = `${String(hh).padStart(2, "0")}:${String(min).padStart(2, "0")}`;
      if (isAllowed(mm)) {
        before = key;
        break;
      }
    }
    for (let i = step; i <= maxForward; i += step) {
      const mm = chosenMinutes + i;
      if (mm > 23 * 60 + 59) break;
      const hh = Math.floor(mm / 60) % 24;
      const min = mm % 60;
      const key = `${String(hh).padStart(2, "0")}:${String(min).padStart(2, "0")}`;
      if (isAllowed(mm)) {
        after = key;
        break;
      }
    }
    const raw = [before, after].filter(Boolean);
    const alternatives = raw.filter((t) => isTimeValidForSchedule(dateStr, t));
    return { free: false, alternatives };
  };

  const doScheduleTodo = async (todo, dateStr, timeStr, platform) => {
    if (!todo?.uid) {
      toast.error("חסר מזהה משתמש למשימה. יש לרענן את העמוד ולנסות שוב.");
      return null;
    }
    const titlePart = todo.title.split(" ")[0];
    const requestType = scheduleTitleDict[titlePart] || "ac";
    const [y, mo, d] = dateStr.split("-").map(Number);
    const [h, min] = timeStr.split(":").map(Number);
    const localScheduled = new Date(y, mo - 1, d, h, min, 0, 0);
    const executionDate = localScheduled.toISOString();
    const res = await dispatch(
      sendSmsScheduled({
        uid: todo.uid,
        title: requestType,
        executionDate,
        platform,
      }),
    );
    if (res?.status === 409 || res?.error?.status === 409) {
      const body = res?.data ?? res?.error;
      const alternatives = body?.data?.alternatives ?? body?.alternatives ?? [];
      toast.warning(
        alternatives.length
          ? `הדקה תפוסה. שעות פנויות: ${alternatives.join(", ")}`
          : "הדקה תפוסה",
      );
      return { conflict: true, alternatives };
    }
    if (res?.error) {
      toast.error(res.error?.message || res.error || "שגיאה בתזמון");
      return null;
    }
    const id =
      res?.data?.data?.scheduledRequestId ?? res?.data?.scheduledRequestId;
    if (!id) {
      toast.error("לא התקבל מזהה תזמון");
      return null;
    }
    const scheduledAt = localScheduled.toISOString();
    const scheduleBody = { ScheduledRequestUid: id, scheduledAt };
    if (user.role === 1) {
      await dispatch(setSchedule(todo._id, scheduleBody));
    } else {
      await dispatch(edit(todo._id, scheduleBody));
    }
    toast.success("התזמון בוצע בהצלחה");
    return id;
  };

  const handleScheduleConfirm = async () => {
    if (!scheduleModalTodo) return;
    if (!canRole5ScheduleMessages(user, todos)) {
      toastRole5PackageIncomplete();
      return;
    }
    const dateStr = getTaskDateStr(scheduleModalTodo.executionDate);
    const timeStr =
      scheduleTime.length === 5 ? scheduleTime : scheduleTime.slice(0, 5);
    if (!isTimeValidForSchedule(dateStr, timeStr)) {
      toast.warning("יש לבחור שעה שעוד לא חלפה, ולפחות 5 דקות מעכשיו");
      return;
    }
    setScheduleLoading(true);
    const platform = scheduleModalTodo.title.includes("ווצאפ")
      ? "whatsapp"
      : "sms";
    const availability = await checkScheduleAvailability(
      scheduleModalTodo,
      timeStr,
      platform,
    );
    if (availability.free) {
      const ok = await doScheduleTodo(
        scheduleModalTodo,
        dateStr,
        timeStr,
        platform,
      );
      setScheduleLoading(false);
      if (ok && typeof ok === "object" && ok.conflict) {
        setScheduleAlternatives(ok.alternatives ?? []);
        return;
      }
      if (ok) {
        setScheduleModalTodo(null);
        setScheduleAlternatives(null);
      }
      return;
    }
    if (availability.alternatives && availability.alternatives.length >= 1) {
      setScheduleAlternatives(availability.alternatives);
    } else {
      toast.warning("לא נמצאה שעה פנויה קרובה");
    }
    setScheduleLoading(false);
  };

  const handleScheduleAlternative = async (timeStr) => {
    if (!scheduleModalTodo) return;
    if (!canRole5ScheduleMessages(user, todos)) {
      toastRole5PackageIncomplete();
      return;
    }
    setScheduleLoading(true);
    const dateStr = getTaskDateStr(scheduleModalTodo.executionDate);
    const platform = scheduleModalTodo.title.includes("ווצאפ")
      ? "whatsapp"
      : "sms";
    const ok = await doScheduleTodo(
      scheduleModalTodo,
      dateStr,
      timeStr,
      platform,
    );
    setScheduleLoading(false);
    if (ok && typeof ok === "object" && ok.conflict) {
      setScheduleAlternatives(ok.alternatives ?? []);
      return;
    }
    if (ok) {
      setScheduleModalTodo(null);
      setScheduleAlternatives(null);
    }
  };

  const handleCancelScheduleConfirm = async () => {
    if (!cancelScheduleTodo) return;
    setScheduleLoading(true);
    const { data, error, status } = await post(
      ServerRoutes.SmsScheduled.cancelById,
      {
        taskId: cancelScheduleTodo.ScheduledRequestUid,
      },
    );
    setScheduleLoading(false);
    if (status !== 200 || error) {
      toast.error(error?.message || error || "שגיאה בביטול התזמון");
      setCancelScheduleTodo(null);
      return;
    }
    const clearBody = { ScheduledRequestUid: null, scheduledAt: null };
    if (user.role === 1) {
      dispatch(setSchedule(cancelScheduleTodo._id, clearBody));
    } else {
      dispatch(edit(cancelScheduleTodo._id, clearBody));
    }
    toast.success("התזמון בוטל");
    setCancelScheduleTodo(null);
  };

  const pickInitialBulkTime = (todo) => {
    const [start, end] = getPreferredWindowByTitle(todo?.title);
    const dateStr = getTaskDateStr(todo?.executionDate);
    const minByDate = getMinScheduleTime(dateStr);
    const startM = timeToMinutes(start);
    const endM = timeToMinutes(end);
    let candidate = Math.max(startM, timeToMinutes(minByDate));
    if (candidate > endM) candidate = endM;
    return minutesToTime(candidate);
  };

  const pickAfterAlternative = (alternatives = [], baseTime) => {
    if (!Array.isArray(alternatives) || alternatives.length === 0) return null;
    const base = timeToMinutes(baseTime);
    const after = alternatives
      .map((t) => ({ t, m: timeToMinutes(t) }))
      .filter((x) => x.m > base)
      .sort((a, b) => a.m - b.m);
    if (after.length > 0) return after[0].t;
    return alternatives[alternatives.length - 1] || alternatives[0];
  };

  const getSchedulableTodos = () => {
    const arr = Object.values(todos || {});
    return arr
      .filter((todo) => {
        const first = String(todo?.title || "").split(" ")[0];
        const isSchedulableType = [
          "הודעה",
          "ווצאפ",
          "תזכורת",
          "תודה",
          "קדם",
        ].includes(first);
        return (
          isSchedulableType &&
          !todo.done &&
          !todo.ScheduledRequestUid &&
          !isTaskDatePassed(todo.executionDate)
        );
      })
      .sort(
        (a, b) =>
          new Date(a.executionDate).getTime() -
          new Date(b.executionDate).getTime(),
      );
  };

  const scheduleSingleTodoBulk = async (todo) => {
    const dateStr = getTaskDateStr(todo.executionDate);
    const platform = todo.title.includes("ווצאפ") ? "whatsapp" : "sms";
    let chosenTime = pickInitialBulkTime(todo);

    for (let attempt = 0; attempt < 25; attempt++) {
      if (!isTimeValidForSchedule(dateStr, chosenTime)) {
        const next = timeToMinutes(chosenTime) + 10;
        if (next > 23 * 60 + 59) return false;
        chosenTime = minutesToTime(next);
        continue;
      }

      const availability = await checkScheduleAvailability(
        todo,
        chosenTime,
        platform,
      );
      if (!availability.free) {
        const nextFromAlternatives = pickAfterAlternative(
          availability.alternatives,
          chosenTime,
        );
        if (nextFromAlternatives) {
          chosenTime = nextFromAlternatives;
          continue;
        }
        const next = timeToMinutes(chosenTime) + 10;
        if (next > 23 * 60 + 59) return false;
        chosenTime = minutesToTime(next);
        continue;
      }

      const ok = await doScheduleTodo(todo, dateStr, chosenTime, platform);
      if (ok && typeof ok === "object" && ok.conflict) {
        const nextFromAlternatives = pickAfterAlternative(
          ok.alternatives,
          chosenTime,
        );
        if (nextFromAlternatives) {
          chosenTime = nextFromAlternatives;
          continue;
        }
        const next = timeToMinutes(chosenTime) + 10;
        if (next > 23 * 60 + 59) return false;
        chosenTime = minutesToTime(next);
        continue;
      }
      return Boolean(ok);
    }
    return false;
  };

  const handleBulkAutoSchedule = async () => {
    if (!(user.role === 6 || user.role === 5 || user.role === 1)) {
      toast.warning("אין הרשאה לתזמון");
      return;
    }
    if (!isEventReadyForSchedule(user)) {
      toast.warning("יש להשלים תחילה את פרטי האירוע לפני תזמון");
      return;
    }
    if (!canRole5ScheduleMessages(user, todos)) {
      toastRole5PackageIncomplete();
      return;
    }

    const toSchedule = getSchedulableTodos();
    if (toSchedule.length === 0) {
      toast.info("אין משימות זמינות לתזמון");
      return;
    }

    setBulkScheduleLoading(true);
    setShowLoading(true);
    let successCount = 0;
    let failedCount = 0;

    for (let i = 0; i < toSchedule.length; i++) {
      const ok = await scheduleSingleTodoBulk(toSchedule[i]);
      if (ok) successCount++;
      else failedCount++;
    }

    setShowLoading(false);
    setBulkScheduleLoading(false);

    if (failedCount === 0) toast.success("כל המשימות תוזמנו בהצלחה");
    else if (successCount > 0)
      toast.warning(`תוזמנו ${successCount} משימות, ${failedCount} לא תוזמנו`);
    else toast.error("לא ניתן היה לתזמן את המשימות");
  };

  let todosArray = useMemo(() => {
    let arr = [];
    let sortedArray = [];
    if (Object.keys(todos).length > 0) {
      for (const [key, value] of Object.entries(todos)) sortedArray.push(value);
      sortedArray.sort(
        (a, b) => new Date(a["executionDate"]) - new Date(b["executionDate"]),
      );
      for (let i = 0; i < sortedArray.length; i++) {
        if (
          !isTal &&
          (sortedArray[i].title == "זירוז שני" ||
            sortedArray[i].title == "זירוז ראשון")
        )
          continue;
        arr.push(
          <TodoCard
            key={i}
            onClick={() => {
              if (sortedArray[i].title === "הסדרת תשלום" && !isTal)
                handleSetPayment(sortedArray[i].executionDate);
              else {
                if (
                  user.canChangeTodos ||
                  isTal ||
                  user.role === 6 ||
                  user.role === 5 ||
                  (user.role === 1 && isTal)
                )
                  setShowEditTodo(sortedArray[i]);
                else
                  toast.warning("אינך מורשה לערוך את היומן - יש לפנות לתמיכה");
              }
            }}
            style={{
              border: "2px solid #f2f2f2",
              borderRadius: "5px",
              background: "inherit",
            }}
          >
            <div>{sortedArray[i].title}</div>
            <div style={{ fontSize: "13px" }}>
              {sortedArray[i].executionDate
                .replace(/T.*/, "")
                .split("-")
                .reverse()
                .join("/")}
            </div>
            {(sortedArray[i].title.split(" ")[0] == "הודעה" ||
              sortedArray[i].title.split(" ")[0] == "ווצאפ" ||
              sortedArray[i].title.split(" ")[0] == "תזכורת" ||
              sortedArray[i].title.split(" ")[0] == "תודה" ||
              sortedArray[i].title.split(" ")[0] == "קדם") && (
              <div
                style={{
                  fontSize: "13px",
                  padding: "3px 5px",
                  background: "#f2f2f2",
                  borderRadius: "5px",
                }}
              >
                {sortedArray[i].tal}
              </div>
            )}

            {sortedArray[i].title.split(" ")[0] != "מעבר" &&
              sortedArray[i].title.split(" ")[0] != "הסדרת" &&
              sortedArray[i].title.split(" ")[0] != "לחיצה" &&
              ((user.role === 6 || user.role === 5 || user.role === 1) &&
              ["הודעה", "ווצאפ", "תזכורת", "תודה", "קדם"].includes(
                sortedArray[i].title.split(" ")[0],
              ) ? (
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: "8px",
                    flexWrap: "wrap",
                  }}
                  onClick={(e) => e.stopPropagation()}
                >
                  {sortedArray[i].done ||
                  (sortedArray[i].ScheduledRequestUid &&
                    sortedArray[i].scheduleStatus === "sent") ? (
                    <span style={{ fontSize: "13px", color: "#2e7d32" }}>
                      נשלח בהצלחה
                    </span>
                  ) : sortedArray[i].ScheduledRequestUid ? (
                    sortedArray[i].scheduleStatus === "failed" ? (
                      <span style={{ fontSize: "13px", color: "#c62828" }}>
                        נכשל
                        {sortedArray[i].scheduleErrorMessage
                          ? ` – ${sortedArray[i].scheduleErrorMessage}`
                          : ""}
                      </span>
                    ) : (
                      <>
                        <span style={{ fontSize: "13px" }}>
                          {sortedArray[i].scheduledAt
                            ? toIsraelHHmm(sortedArray[i].scheduledAt)
                            : "מתוזמן"}
                        </span>
                        <button
                          type="button"
                          onClick={(e) => {
                            e.stopPropagation();
                            setCancelScheduleTodo(sortedArray[i]);
                          }}
                          style={{
                            fontSize: "12px",
                            padding: "4px 8px",
                            background: "#e0e0e0",
                            border: "none",
                            borderRadius: "4px",
                            cursor: "pointer",
                          }}
                        >
                          ביטול תזמון
                        </button>
                      </>
                    )
                  ) : null}
                  {!sortedArray[i].ScheduledRequestUid &&
                  !sortedArray[i].done &&
                  isEventReadyForSchedule(user) &&
                  !isTaskDatePassed(sortedArray[i].executionDate) ? (
                    <button
                      type="button"
                      onClick={(e) => {
                        e.stopPropagation();
                        if (role5ScheduleBlocked) {
                          toastRole5PackageIncomplete();
                          return;
                        }
                        const todo = sortedArray[i];
                        setScheduleModalTodo(todo);
                        setScheduleTime(getDefaultScheduleTime());
                        setScheduleAlternatives(null);
                      }}
                      style={{
                        fontSize: "13px",
                        padding: "6px 12px",
                        background: role5ScheduleBlocked ? "#bdbdbd" : "#7b96c4",
                        color: "#fff",
                        border: "none",
                        borderRadius: "5px",
                        cursor: role5ScheduleBlocked ? "not-allowed" : "pointer",
                        opacity: role5ScheduleBlocked ? 0.85 : 1,
                      }}
                      title={
                        role5ScheduleBlocked
                          ? "יש להוסיף קודם את כל משימות החבילה ללו״ז"
                          : undefined
                      }
                    >
                      תזמון
                    </button>
                  ) : null}
                </div>
              ) : (
                <div
                  style={{ width: "min-content" }}
                  onClick={(e) => e.stopPropagation()}
                >
                  <Switcher
                    onOfColor={"#C0C0C0"}
                    color={"#7b96c4"}
                    checked={sortedArray[i].done}
                    onChange={() => {
                      if (
                        isTal &&
                        sortedArray[i].title.split(" ")[0] === "שיחה"
                      )
                        if (sortedArray[i].done === false)
                          handleSetDone(
                            sortedArray[i]._id,
                            !sortedArray[i].done,
                            sortedArray[i].title.split(" ")[1],
                          );
                        else toast.warning("לא ניתן לשנות סטטוס משימה");
                      else toast.warning("רק מנהל מערכת יכול לסמן סטטוס בוצע");
                    }}
                  />
                </div>
              ))}
          </TodoCard>,
        );
      }
    }
    return arr;
  }, [todos, user?.role, user?.deal, role5ScheduleBlocked]);

  return (
    <div
      style={{
        width: "100%",
        height: `${window.screen.availHeight}px`,
        background: "linear-gradient(to bottom, #e2ebff,#fbfdff, #ffffff)",
      }}
    >
      <BurgerMenu
        isOpen={isMainMenuBurgerOpen}
        onToggle={() => setIsMainMenuBurgerOpen(!isMainMenuBurgerOpen)}
        position="fixed"
        top="0px"
        left="0px"
      >
        <MenuItem
          icon={
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none">
              <path
                d="M3 7h18M3 12h18M3 17h18"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
          }
          text="אורחים"
          onClick={() => {
            history.push(ClientRoutes.User.main);
            setIsMainMenuBurgerOpen(false);
          }}
          color="#333"
        />
        <MenuItem
          icon={
            <>
              <style>
                {`
                  @keyframes flameBlink {
                    0% { opacity: 1; transform: scale(1); filter: drop-shadow(0 0 6px rgba(255,152,0,0.9)); }
                    50% { opacity: 0.65; transform: scale(1.15); filter: drop-shadow(0 0 14px rgba(255,152,0,1)); }
                    100% { opacity: 1; transform: scale(1); filter: drop-shadow(0 0 6px rgba(255,152,0,0.9)); }
                  }
                `}
              </style>
              <span
                role="img"
                aria-label="אש"
                style={{
                  display: "inline-flex",
                  alignItems: "center",
                  justifyContent: "center",
                  width: "16px",
                  height: "16px",
                  fontSize: "16px",
                  animation: "flameBlink 0.9s infinite ease-in-out",
                }}
              >
                🔥
              </span>
            </>
          }
          text={bulkScheduleLoading ? "מתזמן..." : "תזמון אוטומטי לכל המשימות"}
          onClick={async () => {
            setIsMainMenuBurgerOpen(false);
            if (!bulkScheduleLoading) await handleBulkAutoSchedule();
          }}
          color="#333"
          disabled={bulkScheduleLoading || role5ScheduleBlocked}
        />

        <MenuItem
          icon={
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none">
              <path
                d="M12 5v14M5 12h14"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
          }
          text="הוספת משימה"
          onClick={() => {
            if (
              user.canChangeTodos ||
              isTal ||
              user.role === 6 ||
              user.role === 5 ||
              (user.role === 1 && isTal)
            ) {
              setShowAddTodo(true);
              setIsMainMenuBurgerOpen(false);
            } else {
              toast.warning("אינך מורשה לערוך את היומן - יש לפנות לתמיכה");
              setIsMainMenuBurgerOpen(false);
            }
          }}
          color="#333"
        />

        {/* <MenuItem
          icon={
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none">
              <path
                d="M9 11H15M9 15H15M9 7H15M5 3H19C20.1046 3 21 3.89543 21 5V19C21 20.1046 20.1046 21 19 21H5C3.89543 21 3 20.1046 3 19V5C3 3.89543 3.89543 3 5 3Z"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
          }
          text="דוחות"
          onClick={() => {
            setShowMenu(true);
            setIsMainMenuBurgerOpen(false);
          }}
          color="#333"
        /> */}

        <MenuItem
          icon={
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none">
              <path
                d="M12 2L2 7L12 12L22 7L12 2Z"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <path
                d="M2 17L12 22L22 17"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <path
                d="M2 12L12 17L22 12"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
          }
          text="הדרכות"
          onClick={() => {
            history.push(ClientRoutes.User.instruction);
            setIsMainMenuBurgerOpen(false);
          }}
          color="#333"
        />
        {isTal && (
          <MenuItem
            icon={
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none">
                <path
                  d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
                <polyline
                  points="14,2 14,8 20,8"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
                <line
                  x1="16"
                  y1="13"
                  x2="8"
                  y2="13"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
                <line
                  x1="16"
                  y1="17"
                  x2="8"
                  y2="17"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
                <polyline
                  points="22,6 12,13 2,6"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
            }
            text="הזמנה"
            onClick={() => {
              history.push(ClientRoutes.User.editDetails);
              setIsMainMenuBurgerOpen(false);
            }}
            color="#333"
          />
        )}

        <MenuItem
          icon={
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none">
              <path
                d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4M16 3h4a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2h-4M7 16l4-4 4 4M12 12v9"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
          }
          text="התנתקות"
          onClick={() => {
            setShowLogout(true);
            setIsMainMenuBurgerOpen(false);
          }}
          color="#333"
        />
      </BurgerMenu>
      <FlexRowBetween style={{ justifyContent: "center", margin: "30px auto" }}>
        <BoldFont csize={"32px"} psize={"28px"}>
          לו״ז עבודה
        </BoldFont>
      </FlexRowBetween>
      <FlexRowBetween
        style={{
          justifyContent: "center",
          margin: "30px auto",
          width: "80%",
          margin: "0 auto",
        }}
      >
        {user?.role == 6 ? (
          <div>
            <span>
              {
                "ההמלצה שלנו הינה ליצור יומיים שלושה מרווח בין ההודעות ולשמור על הסדר הבא: הודעה ראשונה -> הודעה שניה -> ווצאפ ראשון -> ווצאפ שני -> ווצאפ שלישי -> שיחה ראשונה -> שיחה שניה -> שיחה שלישית -> שיחה רביעית -> קדם תזכורת -> תזכורת סמס -> תזכורת ווצאפ -> תודה"
              }
            </span>
          </div>
        ) : (
          <MediumFont
            csize={"22px"}
            psize={"18px"}
            style={{ textAlign: "center" }}
          >
            * נציין כי לפעמים תהיה חריגה של יום/יומיים בביצוע השיחות (הלוז ישתנה
            בהתאם לאילוצים)
          </MediumFont>
        )}
      </FlexRowBetween>

      <ListHolder>{todosArray}</ListHolder>
      <div style={{ height: "40px" }} />

      {showLoading && <FilledLoading />}

      {showAddTodo && (
        <GenericModal
          init={setShowAddTodo}
          div={
            <Add
              key={`add-${user?._id}-${user?.role}-${user?.deal}`}
              init={setShowAddTodo}
              producer={user.producer}
              userRole={user?.role}
              isTal={isTal}
              eventDate={user?.date}
              userDeal={user?.deal}
            />
          }
        />
      )}

      {showEditTodo && (
        <GenericModal
          init={setShowEditTodo}
          div={
            <Edit
              key={showEditTodo._id}
              todo={showEditTodo}
              init={setShowEditTodo}
              userRole={user?.role}
              isTal={isTal}
              eventDate={user?.date}
              userDeal={user?.deal}
            />
          }
        />
      )}

      {showMenu && (
        <GenericModal
          init={setShowMenu}
          div={
            <ToolsOptions
              data={[
                <TextWithPic
                  key={1}
                  onClick={() => history.push(ClientRoutes.User.main)}
                >
                  מוזמנים
                </TextWithPic>,
                <TextWithPic
                  onClick={() => history.push(ClientRoutes.User.instruction)}
                  key={3}
                >
                  הדרכות
                </TextWithPic>,
                <TextWithPic
                  onClick={() => history.push(ClientRoutes.User.editDetails)}
                  key={3}
                >
                  הזמנה
                </TextWithPic>,
              ]}
            />
          }
        />
      )}

      {showLogout && (
        <GenericModal
          init={setShowLogout}
          div={<LogoutSpecipic init={setShowLogout} />}
        />
      )}

      {showPaymentDetails && (
        <GenericModal
          init={setShowPaymentDetails}
          div={
            <GetPaymentDetails
              data={showPaymentDetails}
              init={setShowPaymentDetails}
            />
          }
        />
      )}

      {showCallsRecord && (
        <GenericModal
          init={setShowCallsRecord}
          div={
            <SetCallsRecord stats={showCallsRecord} init={setShowCallsRecord} />
          }
        />
      )}

      {scheduleModalTodo && (
        <GenericModal
          init={() => {
            setScheduleModalTodo(null);
            setScheduleAlternatives(null);
          }}
          div={
            <div
              onClick={(e) => e.stopPropagation()}
              style={{
                padding: "20px",
                minWidth: "280px",
                background: "#fff",
                borderRadius: "12px",
                border: "2px solid #7b96c4",
                boxShadow: "0 4px 20px rgba(0,0,0,0.15)",
              }}
            >
              <BoldFont style={{ marginBottom: "12px", display: "block" }}>
                בחירת שעת תזמון
              </BoldFont>
              <div style={{ fontSize: "14px", marginBottom: "8px" }}>
                תאריך:{" "}
                {scheduleModalTodo.executionDate
                  ?.replace?.(/T.*/, "")
                  ?.split("-")
                  ?.reverse()
                  ?.join("/")}
              </div>
              {!scheduleAlternatives ? (
                <>
                  <label
                    style={{
                      display: "block",
                      marginBottom: "4px",
                      fontSize: "14px",
                    }}
                  >
                    שעה (מומלץ בין השעות 09:30-19:30)
                  </label>
                  <input
                    type="time"
                    value={scheduleTime}
                    min={
                      scheduleModalTodo
                        ? getMinScheduleTime(
                            getTaskDateStr(scheduleModalTodo.executionDate),
                          )
                        : "00:00"
                    }
                    onChange={(e) => setScheduleTime(e.target.value)}
                    style={{
                      marginBottom: "16px",
                      padding: "8px",
                      fontSize: "16px",
                    }}
                  />
                  <FlexRowBetween style={{ gap: "8px" }}>
                    <button
                      type="button"
                      onClick={handleScheduleConfirm}
                      disabled={scheduleLoading}
                      style={{
                        padding: "8px 16px",
                        background: "#7b96c4",
                        color: "#fff",
                        border: "none",
                        borderRadius: "5px",
                        cursor: scheduleLoading ? "wait" : "pointer",
                      }}
                    >
                      {scheduleLoading ? "בודק..." : "אשר"}
                    </button>
                    <button
                      type="button"
                      onClick={() => {
                        setScheduleModalTodo(null);
                        setScheduleAlternatives(null);
                      }}
                      style={{
                        padding: "8px 16px",
                        background: "#e0e0e0",
                        border: "none",
                        borderRadius: "5px",
                        cursor: "pointer",
                      }}
                    >
                      ביטול
                    </button>
                  </FlexRowBetween>
                </>
              ) : (
                <>
                  <MediumFont style={{ marginBottom: "12px" }}>
                    השעה שבחרת תפוסה אבל פנוי:
                  </MediumFont>
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      gap: "8px",
                    }}
                  >
                    {scheduleAlternatives.map((t) => (
                      <button
                        key={t}
                        type="button"
                        onClick={() => handleScheduleAlternative(t)}
                        disabled={scheduleLoading}
                        style={{
                          padding: "10px",
                          background: "#7b96c4",
                          color: "#fff",
                          border: "none",
                          borderRadius: "5px",
                          cursor: scheduleLoading ? "wait" : "pointer",
                        }}
                      >
                        {t}
                      </button>
                    ))}
                  </div>
                  <button
                    type="button"
                    onClick={() => setScheduleAlternatives(null)}
                    style={{
                      marginTop: "12px",
                      padding: "6px 12px",
                      background: "transparent",
                      border: "1px solid #999",
                      borderRadius: "5px",
                      cursor: "pointer",
                      fontSize: "13px",
                    }}
                  >
                    חזרה לבחירת שעה
                  </button>
                </>
              )}
            </div>
          }
        />
      )}

      {cancelScheduleTodo && (
        <GenericModal
          init={() => setCancelScheduleTodo(null)}
          div={
            <YesNoModal
              title="ביטול תזמון"
              body="האם אתה בטוח שברצונך למחוק את התזמון?"
              yes={() => handleCancelScheduleConfirm()}
              no={() => setCancelScheduleTodo(null)}
              yesText="מחק"
              noText="ביטול"
              yesColor="#c62828"
            />
          }
        />
      )}
    </div>
  );
};

export default MainTodos;
